<template>
  <div :class="$style['user-wallet-message']">
    <table>
      <pt-message-table-item label="钱包余额" :class="$style['user-wallet-table-item']">
        <span :class="$style['wallet-amount-text']">{{walletDetail.amount?('¥'+walletDetail.amount):0}}</span>
      </pt-message-table-item>
    </table>
    <div :class="$style['user-wallet-header-title']">银行卡信息</div>
    <div :class="$style['user-wallet-message-detail']">
      <table>
        <pt-message-table-item label="收款方账户名称">
          <wt-input v-if="isEditUserWallet" v-model="bankAccount.accountName"></wt-input>
          <template v-else>{{bankAccount.accountName}}</template>
        </pt-message-table-item>
        <pt-message-table-item label="开户银行">
           <wt-input v-if="isEditUserWallet" v-model="bankAccount.bankName"></wt-input>
          <template v-else>{{bankAccount.bankName}}</template>
          </pt-message-table-item>
      </table>
      <table>
        <pt-message-table-item label="身份证号">
          <wt-input v-if="isEditUserWallet" v-model="bankAccount.idCard"></wt-input>
          <template v-else>{{bankAccount.id_card}}</template>
        </pt-message-table-item>
        <pt-message-table-item label="开户支行" v-if="isEditUserWallet">
            <wt-input v-model="bankAccount.branchName"></wt-input>
        </pt-message-table-item>
        <pt-message-table-item label="开户行全称" v-else>
            {{(bankAccount.bankName||'')+(bankAccount.branchName||'')}}
        </pt-message-table-item>
      </table>
      <table>
        <pt-message-table-item label="银行预留手机号">
           <wt-input v-if="isEditUserWallet" v-model="bankAccount.mobile"></wt-input>
          <template v-else>{{bankAccount.mobile}}</template>
          </pt-message-table-item>
          <pt-message-table-item label="收款账户">
          <wt-input v-if="isEditUserWallet" v-model="bankAccount.cardNumber"></wt-input>
          <template v-else>{{bankAccount.card_number}}</template>
          </pt-message-table-item>
      </table>
    </div>
    <div :class="$style['user-wallet-header-title']" v-if="wxWithdrawalsAccount">微信支付信息</div>
    <div :class="$style['user-wallet-message-detail']" v-if="wxWithdrawalsAccount">
      <table>
        <pt-message-table-item label="微信实名认证">
          <wt-input v-if="isEditUserWallet" v-model="wxWithdrawalsAccount.userName"></wt-input>
          <template v-else>{{wxWithdrawalsAccount.userName}}</template>
        </pt-message-table-item>
      </table>
       <table>
        <pt-message-table-item label="证件号码">
           <wt-input v-if="isEditUserWallet" v-model="wxWithdrawalsAccount.idCard"></wt-input>
          <template v-else>{{wxWithdrawalsAccount.idCard}}</template>
          </pt-message-table-item>
      </table>
      <table>
        <pt-message-table-item>
        </pt-message-table-item>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    walletDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isEditUserWallet: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      bankAccount: {},
      wxWithdrawalsAccount: {}
    }
  },
  watch: {
    walletDetail: {
      handler: function (val) {
        this.bankAccount = val.bankAccount || {}
        this.wxWithdrawalsAccount = val.wxWithdrawalsAccount || {}
      }
    },
    bankAccount: {
      handler: function (val) {
        this.$emit('change', this.walletDetail)
      },
      deep: true
    },
    wxWithdrawalsAccount: {
      handler: function (val) {
        this.$emit('change', this.walletDetail)
      },
      deep: true
    }
  }
}
</script>
<style module lang="less">
@import "~less/var";
.user-wallet-message{
  padding: 0 20px;
  :global
  .wt-input{
     input{
       min-width: 185px;
       padding: 0 5px !important
     }
  }
}
.user-wallet-message-detail{
  display: flex;
  justify-content: space-between;
  :global
  .pt-message-table-item{
    td{
      line-height: 40px;
    }
  }
}
.user-wallet-table-item{
   :first-child{
      width: 114px;
    }
}
.wallet-amount-text{
  color: @mainColor;
  font-weight: 600;
  font-size: 17px;
  margin-right: 5px;
}
.user-wallet-table-title{
  font-size:23px;
  font-weight:400;
  color:#424242;
}
.user-wallet-header-title{
  margin: .2rem 0 .1rem;
  font-size: 16px;
}
</style>
